import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {TypeButtonListComponent} from './type-button-list.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
  ],
  declarations: [
    TypeButtonListComponent,
  ],
  exports: [
    TypeButtonListComponent,
  ],
})
export class TypeButtonListModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-details/type-components/type-button-list/type-button-list.module.ts